import React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const Scales2Fill = (props: IconProps) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_417_10373)">
                <path
                    d="M3.99935 1.33203C3.99935 1.67403 4.32602 1.9987 4.66602 1.9987H11.3327C11.6747 1.9987 11.9993 1.67203 11.9993 1.33203H13.3327C13.3327 2.4367 12.4373 3.33203 11.3327 3.33203H8.66602L8.66668 4.7067C11.2973 5.03536 13.3327 7.27936 13.3327 9.9987V13.9987C13.3327 14.3667 13.034 14.6654 12.666 14.6654H3.33268C2.96468 14.6654 2.66602 14.3667 2.66602 13.9987V9.9987C2.66602 7.2787 4.70202 5.0347 7.33268 4.7067V3.33203H4.66602C3.55935 3.33203 2.66602 2.4387 2.66602 1.33203H3.99935ZM7.99935 7.33203C6.52602 7.33203 5.33268 8.52536 5.33268 9.9987C5.33268 11.472 6.52602 12.6654 7.99935 12.6654C9.47268 12.6654 10.666 11.472 10.666 9.9987C10.666 9.50403 10.5313 9.04137 10.2967 8.64403L8.47068 10.4707L8.40802 10.5254C8.14668 10.7287 7.76802 10.7107 7.52802 10.47C7.26802 10.21 7.26802 9.78736 7.52802 9.52736L9.35401 7.7007C8.95668 7.46737 8.49402 7.33203 7.99935 7.33203Z"
                    fill={props.color || "#000"}
                />
            </g>
            <defs>
                <clipPath id="clip0_417_10373">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default Scales2Fill
